'use client'
import React, { FC } from 'react'
import classNames from 'classnames'

import styles from './SettingCard.module.css'
import { ChevronRight } from '@mui/icons-material'
import ToggleSwitch from '@/components/toggle-switch'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SettingCard: FC<{
	className?: string
	title: string
	description: string
	enabled: boolean
	onClick?: () => void
	toggle?: boolean
	button?: string
	toggleChecked?: boolean
	onToggle?: (value?: any) => void
	/** Marks operator-only entries with a small badge. */
	admin?: boolean
}> = (props) => {
	const { button, className, toggle, onToggle, toggleChecked, admin } = props
	// "Disconnect" reads as a quiet, reversible action; "Connect" is the CTA.
	const buttonIsPrimary = button ? !/^(disconnect|remove|revoke)/i.test(button) : false

	return (
		<div
			onClick={props?.onClick}
			className={classNames({ [props.className as any]: !!className }, styles.root, {
				[styles.signOut]: props.title === 'Sign out'
			})}
			role="button"
			tabIndex={0}
			onKeyDown={onKeyboardClick(props?.onClick)}
		>
			<div className={styles.content}>
				<div className={classNames(styles.title, 'text-md', 'bold', 'flex items-center gap-2')}>
					{props.title}
					{admin && (
						<span className="rounded-full border border-purple-500/30 bg-purple-500/10 px-1.5 py-px text-[10px] font-semibold text-purple-700 dark:border-purple-400/40 dark:text-purple-300">
							Admin
						</span>
					)}
				</div>
				<div className={classNames(styles.description, 'text-sm', 'regular')}>
					{props.description}
				</div>
			</div>
			<div className={styles.end}>
				{toggle ? (
					<ToggleSwitch checked={toggleChecked} onChange={onToggle} />
				) : button ? (
					<span
						className={classNames(
							'inline-flex h-8 min-w-[104px] shrink-0 items-center justify-center whitespace-nowrap rounded-full px-4 text-xs font-semibold leading-none transition-all duration-150 select-none',
							buttonIsPrimary
								? 'bg-gradient-to-r from-purple-600 to-blue-500 text-white shadow-[0_1px_0_rgba(255,255,255,0.12)_inset] hover:from-purple-500 hover:to-blue-400'
								: 'border border-border bg-background text-foreground/80 hover:border-foreground/30 hover:bg-accent hover:text-foreground'
						)}
					>
						{button}
					</span>
				) : (
					<ChevronRight />
				)}
			</div>
		</div>
	)
}

export default SettingCard
